import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from '../icons';

// "Not sure what fits? Send us a photo." — supply-only remote-advice CTA.
// ASG does not carry out site visits or at-home consultations; customers
// send photos and measurements and we advise remotely. Single CTA to the
// quote form. Static copy.
export default function SendPhotoSection() {
  return (
    <section className="asg-sendphoto">
      <div className="asg-sendphoto-inner">
        <div className="asg-sendphoto-text asg-reveal">
          <p className="asg-section-label">Send Us A Photo</p>
          <h2 className="asg-section-title">Not sure what fits? Send us a photo.</h2>
          <p className="asg-section-body">
            Take a couple of photos of your wall or pergola area, measure the available
            width, and send them through. We will confirm the largest model that will work
            in your space, recommend a fabric, and send a written quote. No site visit
            needed, no obligation.
          </p>
          <ul className="asg-sendphoto-bullets">
            <li><CheckIcon /> The full wall or area from a few metres back</li>
            <li><CheckIcon /> A close-up of the wall surface</li>
            <li><CheckIcon /> Anything in the way - downpipes, windows or meter boxes</li>
          </ul>
          <div className="asg-sendphoto-actions">
            <Link to="/request-quote" className="asg-btn-primary">Send photos and get a quote</Link>
          </div>
        </div>
        <div className="asg-sendphoto-img asg-reveal">
          <img
            src="/images/pergola-intro-v3.webp"
            alt="Charcoal aluminium louvered pergola against a rendered wall - ASG Shading supplies made-to-measure systems across Melbourne"
            loading="lazy"
            width={1024}
            height={1024}
          />
        </div>
      </div>
    </section>
  );
}
